import {Mutation, Action, VuexModule, getModule, Module} from 'vuex-module-decorators'
import store from '../store'
import {DeliousApiClient} from "@/_global/api_clients/DeliousApiClient";

// Delious のユーザ種別
export enum USER_TYPES {
    SUPER_USER = 0,  // 全店ユーザー
    GROUP_USER = 1,  // 店舗グループユーザー
    STORE_USER = 2   // 店舗ユーザー
}

@Module({
    name: "UserStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class UserStore extends VuexModule {
    // state
    private _user: Delious.User = {} as Delious.User;

    // getter
    get user() {
        return this._user || {};
    }

    get isAuthenticated() {
        return this.user.cms_accessible == 1;
    }

    get userType() {
        return this.user.user_type;
    }

    @Action
    public async update() {
        try {
            const user: Delious.User = await DeliousApiClient.getUser();
            this.setUser(user);
        } catch (e) {
        }
    }

    @Mutation
    private setUser(user: Delious.User) {
        this._user = user;
    }
}

export default getModule(UserStore)
